import { render, staticRenderFns } from "./ModelDiv.vue?vue&type=template&id=cd72efde&scoped=true&"
import script from "./ModelDiv.vue?vue&type=script&lang=js&"
export * from "./ModelDiv.vue?vue&type=script&lang=js&"
import style0 from "./ModelDiv.vue?vue&type=style&index=0&id=cd72efde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd72efde",
  null
  
)

export default component.exports